import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import FullScreen from './fullScreen';
import * as Config from "../lib/config";
import { exitFullscreen, isFullscreen } from '../utils/fullscreenHelper';
import './FullScreenView.css';

const FullScreenView = (props) => {
  const navigate = useNavigate();
  const {
    fontSize,
    name,
    isMobile,
    speed,
    RGB,
    isblink,
    blinkSpeend,
    isFlipText,
    bgColor,
    setName,
    color,
    finalResult
  } = props;

  const handleBack = useCallback(async () => {
    try {
      // Exit browser fullscreen mode if currently in fullscreen
      if (isFullscreen()) {
        await exitFullscreen();
        
        // Track fullscreen exit
        if (window.gtag && window.cookieConsentGiven) {
          window.gtag('event', 'fullscreen_exit', {
            event_category: 'User Engagement',
            event_label: 'Exit Fullscreen Mode',
            value: 1
          });
        }
      }
      
      // Navigate back to home
      navigate('/');
    } catch (error) {
      console.error('Error exiting fullscreen:', error);
      // If exit fails, still navigate back
      navigate('/');
    }
  }, [navigate]);

  // Handle ESC key to exit fullscreen
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape' && isFullscreen()) {
        handleBack();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleBack]);

  return (
    <div className="fullscreen-view">
      <button className="back-button" onClick={handleBack}>
        <img
          src={Config.images.leftArrow}
          alt="Back"
          width="24"
          height="24"
        />
      </button>
      
      <FullScreen
        fontSize={fontSize}
        name={name}
        isMobile={isMobile}
        speed={speed}
        RGB={RGB}
        isblink={isblink}
        blinkSpeend={blinkSpeend}
        isFlipText={isFlipText}
        bgColor={bgColor}
        setName={setName}
        color={color}
        finalResult={finalResult}
      />
    </div>
  );
};

export default FullScreenView; 